import React from 'react';
import { FolderOpenIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import Document from './Document';
import Folder from './Folder';
export const FolderStructure = ({
  data,
  checked,
  name,
  removeAttachment,
  setChecked,
  openFolder
}) => {
  const [css] = useStyletron();
  return <div className={css({
    display: 'grid',
    gridGap: '16px',
    gridTemplateColumns: data.length !== 0 ? 'repeat(auto-fill, minmax(200px, 1fr))' : '1fr',
    padding: '28px'
  })}>
      {data.length === 0 && <div className={css({
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      padding: '48px 32px',
      width: '100%',
      '.la-folder-open': {
        fontSize: '32px'
      }
    })}>
          <FolderOpenIcon />
          <h5>No Documents</h5>
        </div>}

      {data.map(node => {
      if (!('node' in node)) {
        return <Document key={node.filename} document={node} checked={checked} setChecked={setChecked} removeDocument={removeAttachment} />;
      } else {
        const treeNode = node;
        return <Folder key={treeNode.name} node={treeNode} projectName={name} openFolder={openFolder} removeAttachment={removeAttachment} />;
      }
    })}
    </div>;
};